import styled from "styled-components";

export const WaveSurferWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
  cursor: pointer;
  & .topContainer {
    display: flex;
    align-items: center;
    width: 300px;
    flex: 2;
    @media (max-width: 768px) {
      width: 100%;
      background: #fbfbff;
      box-shadow: 0px 5.4px 11.7px rgba(108, 136, 170, 0.1);
      border-radius: 8px;
      flex: 1;
    }
    & wave {
      width: 100%;
      height: auto;
    }
  }
  & .controller {
    display: flex;
    @media (max-width: 768px) {
      flex-direction: row-reverse;
      width: 100%;
      flex: 1;
      justify-content: space-between;
    }
  }
`;

export const PlayButton = styled.div`
  @keyframes btnRecord {
    from {
      box-shadow: 0px 0px 0px green;
    }
    to {
      box-shadow: 0px 0px 15px green;
    }
  }

  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 48px;
  height: 48px;
  border-radius: 50%; */
  background: none;
  border: 4px solid ${(props) => (props.mode ? "#41B68C" : "transparent")};
  & svg {
    fill: #6caeff;
    width: 30.12px;
    height: 30.12px;
  }
  img {
    width: 46px;
  }
  border-color: linear-gradient(
    180deg,
    ${(props) => props.color || "#41B68C "} 3.65%,
    ${(props) => props.color || "#3a8368 "} 49.48%,
    ${(props) => props.color || "#41B68C "} 92.71%
  );
  outline: none;
  cursor: pointer;
  /* padding-bottom: 3px; */
  &.active {
    box-shadow: 0px 0px 0px green;
    animation: btnRecord 3s linear 0.3s infinite alternate;
  }
  @media (max-width: 480px) {
    display: flex;
    justify-content: flex-start;
  }
`;

export const WaveDiv = styled.div`
  height: 100%;
  flex: 3;
  cursor: pointer;
  @media (max-width: 480px) {
    &.active {
      display: none;
    }
  }
`;

export const TimerContainer = styled.div`
  font-weight: 400;
  color: var(--text-500);
  font-size: 12px;
  flex: 1;
  display: flex;
  align-items: center;
  margin: 10px 8px 10px 14px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const SelectSpeed = styled.select`
  cursor: pointer;
  margin-right: auto;
  margin-left: 6px;
  padding: 2.5px 3px 0px 0px;
  /* width: 50px; */
  flex: 0.5;
  border-radius: 5px;
  font-size: 10px;
  color: #27548c;
  border: 1px solid #629ee8;
  background: transparent;
  option {
    display: flex;
    margin-right: auto;
  }
`;

export const Mute = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  align-items: center;
  margin: 0 0.5rem;
  & svg {
    width: 24px;
    fill: #629ee8;
    height: 24px;
  }
`;

export const Range = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  input[type="range"] {
    cursor: pointer;
    width: 50px;
    -webkit-appearance: none;
    appearance: none;
    height: 3px;
    border-radius: 3px;
    outline: none;
    outline: none;
    background-color: #6caeff;
    color: #6caeff;
    &::-webkit-slider-runnable-track {
      -webkit-appearance: none;
      box-shadow: none;
      border: none;
      background: transparent;
    }
    &::-webkit-slider-thumb {
      -webkit-appearance: none; /* Override default look */
      appearance: none;
      width: 10px; /* Set a specific slider handle width */
      border-radius: 50%;
      height: 10px; /* Slider handle height */
      background: #6caeff; /* Green background */
      cursor: pointer; /* Cursor on hover */
    }
    &::-moz-range-thumb {
      cursor: pointer;
      height: 10px; /* Slider handle height */
      width: 10px; /* Set a specific slider handle width */
      border-radius: 50%;
      background: #d9dbde;
    }
  }
`;

export const AudioController = styled.div`
  display: flex;
  align-items: center;
`;

export const DropDownContainer = styled.div`
  border-radius: 4px;
  position: relative;
  width: 50px;
  height: 20px;
  display: flex;
  padding: 2px 2px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid var(--primary-600);
  @media (max-width: 1200px) {
    width: 30px;
  }

  & > div {
    display: flex;
    align-items: center;
  }
  & > div span {
    display: block;
    color: var(--text-500);
    font-size: 10px;
    font-weight: 400;
  }
  & > div svg {
    color: var(--primary-600);
    position: absolute;
    right: 2px;
    width: 20px;
    &.open {
      transform: rotate(180deg);
    }
  }
`;
export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #27548c;
  position: absolute;
  font-size: 10px;
  font-weight: 400;
  border: 1px solid var(--primary-600);
  right: -8px;
  left: 0;
  top: 20px;
  z-index: 100;
  background-color: #fff;
  border-radius: 4px;
  &.show {
    display: none;
  }
  & > option {
    width: 100%;
    padding: 4px 4px;
    border-top: 1px solid #e9ebf8;
    &:last-child {
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      border-top: 1px solid #e9ebf8;
    }
    &:hover {
      background-color: #d1e6ff;
    }
  }
`;
